module.exports = __webpack_public_path__ + "static/media/icon-new.04da35b4.svg";